/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Trans } from 'react-i18next';
import { Divider, Grid, makeStyles, Typography } from '@material-ui/core';
import Tooltip from '../../common/Tooltip';
import { uiSchemaProperties } from '../../../shared/enums/uiSchemaProperties';

const useStyles = makeStyles(theme => ({
  title: {
    color: theme.palette.titleText,
  },
}));

function getHeaderNumberVariant(id) {
  const path = id.replace(/_(\d+)_?/g, '[$1]');
  const match = path.match(/_/g);
  const nestedLevelCount = match ? match.length : 1;
  return `h${nestedLevelCount + 1}`;
}

const TitleField = (props) => {
  const classes = useStyles();
  const { title, id, variant, uiSchema = {} } = props;
  const tooltip = uiSchema[uiSchemaProperties.UI_TOOLTIP];
  const headerNumberVariant = variant || getHeaderNumberVariant(id);

  return (
    <>
      <Grid container direction="row" alignItems="center">
        <Typography
          id={`${id}`}
          data-testid={`${id ? `${id}-` : ''}title`}
          variant={headerNumberVariant}
          className={classes.title}
        >
          {title}
        </Typography>
        {tooltip && <Tooltip customAria={tooltip} title={<Trans i18nKey={tooltip} />} />}
      </Grid>
      {headerNumberVariant === 'h2' && !variant && <Divider data-testid={`${id ? `${id}-` : ''}divider`} />}
    </>
  );
};

export default TitleField;
